import React, { useEffect, useRef } from 'react';

const TrafficLayer = ({ map, maps, enabled = false }) => {
  const trafficLayerRef = useRef(null);

  useEffect(() => {
    if (!map || !maps) return;

    if (enabled) {
      // Create traffic layer
      if (!trafficLayerRef.current) {
        trafficLayerRef.current = new maps.TrafficLayer({
          autoRefresh: true,
        });
        trafficLayerRef.current.setMap(map);
      }
    } else {
      // Remove traffic layer
      if (trafficLayerRef.current) {
        trafficLayerRef.current.setMap(null);
        trafficLayerRef.current = null;
      }
    }

    // Cleanup on unmount
    return () => {
      if (trafficLayerRef.current) {
        trafficLayerRef.current.setMap(null);
      }
    };
  }, [map, maps, enabled]);

  return null; // This component doesn't render anything
};

export default TrafficLayer;

